import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "./AbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class HasSpecificLengthValidation extends AbstractValidation {
  key = "hasSpecificLength";

  constructor(
    public readonly specificLength: number,
    customErrorMessage?: CustomErrorMessage,
    public readonly specificLengthOnInputs?: boolean
  ) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    return typeof value === "string" && value ? value.length === this.specificLength : true;
  };

  defaultMessage = (label: string): string =>
    translate("Generation_Form_{label}MoetBestaanUit{specificLength}Characters", { label: label, specificLength: this.specificLength.toString() });
}
